"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.axiosGetWithRetries = void 0;
const axios_1 = __importDefault(require("axios"));
const retry_1 = require("./retry");
async function axiosGetWithRetries(args) {
    return (await (0, retry_1.retry)({
        fn: async () => await axios_1.default.get(args.url, { timeout: args.timeout }),
        fnName: `axios.get`,
        maxRetries: args.retryLimit,
        waitBetweenMs: args.retryDelayMilliseconds,
    })());
}
exports.axiosGetWithRetries = axiosGetWithRetries;
//# sourceMappingURL=axios-retry.js.map